import Helper from '../../../models/Helper';

const URI = '/learning-outcomes';

/**
 * @desc Helper for courses.
 */
class LearningOutcomesHelper extends Helper {
  constructor(api) {
    super(api, URI);
  }

  /**
   * @desc Get learning outcomes.
   * @param {string} search term
   * @param {string} lang
   * @return {Promise<Array<LearningOutcome>>} The promise handling the request.
   * @example
   * const courseId = 1234;
   * const response = await myClient.helpers.learningContent.getLearningOutcomes(search, lang);
   */
  getLearningOutcomes(search: string, lang: string) {
    const request = super.find({ search, lang }, false);

    return request.execute();
  }
}

export default LearningOutcomesHelper;
